import {Mapper} from '@s-ui/domain'

export class FromSpecsParamsToSearchUrlValueObjectMapper extends Mapper {
  constructor({config, fromFormParamsToSearchUrlFormValueObjectMapper}) {
    super()
    this._config = config
    this._fromFormParamsToSearchUrlFormValueObjectMapper = fromFormParamsToSearchUrlFormValueObjectMapper
    this._baseUrl = this._config.get('API_URL')
    this._defaultCategoryId = this._config.get('search').DEFAULT_CATEGORY1_ID
    this._vehicleSpecsContext = this._config.get('vehicles').VEHICLE_SPECS_CONTEXT
  }

  _cleanParams = (params = {}) => JSON.parse(JSON.stringify(params))

  _getDefaultSearchUrl = ({dataSource, nextField, params, resourceName, vehicleCategoryId}) => {
    const {MODELS_VERSION} = this._vehicleSpecsContext
    const apiUrl = `${this._baseUrl}/${resourceName}`
    const defaultParams = {}

    if (nextField !== MODELS_VERSION) {
      // models-version endpoint deals with categoryId, not section1Id as search endpoints do
      defaultParams.section1Id = vehicleCategoryId
    }

    const requestParams = {
      ...defaultParams,
      ...this._cleanParams(params)
    }

    this._fromFormParamsToSearchUrlFormValueObjectMapper.setParams({
      apiUrl,
      dataSource,
      nextField,
      requestParams
    })
  }

  map = ({
    dataSource = '',
    nextField,
    params = {},
    resourceName = 'vehicle-specs/v1',
    vehicleCategoryId = this._defaultCategoryId
  } = {}) => {
    this._getDefaultSearchUrl({
      dataSource,
      nextField,
      params,
      resourceName,
      vehicleCategoryId
    })

    return this._fromFormParamsToSearchUrlFormValueObjectMapper.map()
  }
}
